import axios from "axios";
import { FETCH_ALL_ARTICLE_API, FETCH_ARTICLES_BY_DEPARTMENT_API } from "../Constants/Apis";

export const getArticles = async () => {
  try {
    return axios.get(FETCH_ALL_ARTICLE_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createArticle = async (payload) => {
  try {
    return axios.post(FETCH_ALL_ARTICLE_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateArticle = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_ARTICLE_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteArticle = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_ARTICLE_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const getArticlesWithColors = async (searchKeyword, filteredInfo, sorter, pagination) => {
  try {
    const params = new URLSearchParams();
    if (searchKeyword) params.append('searchKeyword', searchKeyword);
    if (filteredInfo) params.append('filteredInfo', JSON.stringify(filteredInfo));
    if (sorter) params.append('sorter', JSON.stringify(sorter));
    if (pagination) {
      // Send pagination parameters individually, not as a JSON string
      if (pagination.current) params.append('current', pagination.current);
      if (pagination.pageSize) params.append('pageSize', pagination.pageSize);
    }
    
    const queryString = params.toString();
    const url = queryString ? `${FETCH_ALL_ARTICLE_API}/with-colors?${queryString}` : FETCH_ALL_ARTICLE_API + "/with-colors";
    
    return axios.get(url);
  } catch (e) {
    return console.log(e);
  }
};

export const getArticlesByDepartment = async (deptId, searchKeyword) => {
  try {
    const params = new URLSearchParams();
    params.append('deptId', deptId);
    if (searchKeyword) params.append('searchKeyword', searchKeyword);
    
    const queryString = params.toString();
    const url = `${FETCH_ARTICLES_BY_DEPARTMENT_API}?${queryString}`;
    
    return axios.get(url);
  } catch (e) {
    return console.log(e);
  }
};

export const getMaxArticleCodeByCategory = async (category) => {
  try {
    const params = new URLSearchParams();
    params.append('category', category);
    
    const queryString = params.toString();
    const url = `${FETCH_ALL_ARTICLE_API}/max-code-by-category?${queryString}`;
    
    return axios.get(url);
  } catch (e) {
    return console.log(e);
  }
};

